import React from 'react';

const defaultRoles = [
  'Koordinaattori',
  'Rakennustekniikka',
  'LVIA-järjestelmät',
  'Sähköjärjestelmät'
];

export default function TeamBlockYrityksella({ data, onChange, onBlur }) {
  // Ensure we have a row for each role
  const rows = defaultRoles.map((role, i) => data?.[i] || { role, name: '', company: '' });

  const handleFieldChange = (index, field, value) => {
    const newData = [...rows];
    newData[index] = { ...newData[index], [field]: value };
    onChange(newData);
    onBlur?.(newData);
  };

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Rooli</th>
          <th>Nimi</th>
          <th>Yritys</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            <td>{row.role}</td>
            <td>
             <input
              type="text"
              className="form-control"
              value={row.name}
              onChange={(e) => handleFieldChange(i, 'name', e.target.value)}
              onBlur={() => onBlur?.(rows)}
            />

            </td>
            <td>
          <input
              type="text"
              className="form-control"
              value={row.company}
              onChange={(e) => handleFieldChange(i, 'company', e.target.value)}
              onBlur={() => onBlur?.(rows)}
            />

            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
